export default __webpack_public_path__ + "static/media/photo2.6e504bbd.jpg";